import { render } from "./TheHeaderLogo.vue?vue&type=template&id=096ef85a&scoped=true"
import script from "./TheHeaderLogo.vue?vue&type=script&lang=js"
export * from "./TheHeaderLogo.vue?vue&type=script&lang=js"

import "./TheHeaderLogo.vue?vue&type=style&index=0&id=096ef85a&lang=scss&scoped=true"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096ef85a"]])

export default __exports__